import { render, staticRenderFns } from "./CustomerCategoryArticleBasic.vue?vue&type=template&id=60f1133e&"
import script from "./CustomerCategoryArticleBasic.vue?vue&type=script&lang=js&"
export * from "./CustomerCategoryArticleBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports